import y from "../../../../public/projects/rahul/projects/y.jpg";
import s from "../../../../public/projects/rahul/logo/s.png";
import evergreen from "../../../../public/projects/rahul/projects/ev.jpg"

// aston
import overviewImageaston from "../../../../public/projects/rahul/aston/overview/1.webp";
import bannerDesktopImageaston from "../../../../public/projects/rahul/aston/banner/1.webp";
import bannerMobileImageaston from "../../../../public/projects/rahul/aston/banner/2.webp";
import Locationaston from "../../../../public/projects/rahul/aston/location/1.webp";
import Hightlightsaston from "../../../../public/projects/rahul/aston/highlights/1.webp";
import floorplan1aston from "../../../../public/projects/rahul/aston/floorplan/1.webp";
import floorplan2aston from "../../../../public/projects/rahul/aston/floorplan/2.webp";
import floorplan3aston from "../../../../public/projects/rahul/aston/floorplan/3.webp";
import floorplan4aston from "../../../../public/projects/rahul/aston/floorplan/4.webp";
import floorplan5aston from "../../../../public/projects/rahul/aston/floorplan/5.webp";
import locationiconaston from "../../../../public/projects/rahul/aston/overview/l.png";
import caliconaston from "../../../../public/projects/rahul/aston/overview/c.png";
import newlaunchiconaston from "../../../../public/projects/rahul/aston/overview/n.png";
import gallery1aston from "../../../../public/projects/rahul/aston/gallery/1.webp";
import gallery2aston from "../../../../public/projects/rahul/aston/gallery/2.webp";
import gallery3aston from "../../../../public/projects/rahul/aston/gallery/3.webp";
import gallery4aston from "../../../../public/projects/rahul/aston/gallery/4.webp";
import gallery5aston from "../../../../public/projects/rahul/aston/gallery/5.webp";

// projecttwo
import overviewImageprojecttwo from "../../../../public/projects/rahul/projecttwo/overview/1.webp";
import bannerDesktopImageprojecttwo from "../../../../public/projects/rahul/projecttwo/banner/1.webp";
import bannerMobileImageprojecttwo from "../../../../public/projects/rahul/projecttwo/banner/2.webp";
import Locationprojecttwo from "../../../../public/projects/rahul/projecttwo/location/1.webp";
import Hightlightsprojecttwo from "../../../../public/projects/rahul/projecttwo/highlights/1.webp";
import floorplan1projecttwo from "../../../../public/projects/rahul/projecttwo/floorplan/1.webp";
import floorplan2projecttwo from "../../../../public/projects/rahul/projecttwo/floorplan/2.webp";
import floorplan3projecttwo from "../../../../public/projects/rahul/projecttwo/floorplan/3.webp";
import floorplan4projecttwo from "../../../../public/projects/rahul/projecttwo/floorplan/4.webp";
import floorplan5projecttwo from "../../../../public/projects/rahul/projecttwo/floorplan/5.webp";
import locationiconprojecttwo from "../../../../public/projects/rahul/projecttwo/overview/l.png";
import caliconprojecttwo from "../../../../public/projects/rahul/projecttwo/overview/c.png";
import newlaunchiconprojecttwo from "../../../../public/projects/rahul/projecttwo/overview/n.png";
import gallery1projecttwo from "../../../../public/projects/rahul/projecttwo/gallery/1.webp";
import gallery2projecttwo from "../../../../public/projects/rahul/projecttwo/gallery/2.webp";
import gallery3projecttwo from "../../../../public/projects/rahul/projecttwo/gallery/3.webp";
import gallery4projecttwo from "../../../../public/projects/rahul/projecttwo/gallery/4.webp";
import gallery5projecttwo from "../../../../public/projects/rahul/projecttwo/gallery/5.webp";

// projectthree
import overviewImageprojectthree from "../../../../public/projects/rahul/projectthree/overview/1.webp";
import bannerDesktopImageprojectthree from "../../../../public/projects/rahul/projectthree/banner/1.webp";
import bannerMobileImageprojectthree from "../../../../public/projects/rahul/projectthree/banner/2.webp";
import Locationprojectthree from "../../../../public/projects/rahul/projectthree/location/1.webp";
import Hightlightsprojectthree from "../../../../public/projects/rahul/projectthree/highlights/1.webp";
import floorplan1projectthree from "../../../../public/projects/rahul/projectthree/floorplan/1.webp";
import floorplan2projectthree from "../../../../public/projects/rahul/projectthree/floorplan/2.webp";
import floorplan3projectthree from "../../../../public/projects/rahul/projectthree/floorplan/3.webp";
import floorplan4projectthree from "../../../../public/projects/rahul/projectthree/floorplan/4.webp";
import floorplan5projectthree from "../../../../public/projects/rahul/projectthree/floorplan/5.webp";
import locationiconprojectthree from "../../../../public/projects/rahul/projectthree/overview/l.png";
import caliconprojectthree from "../../../../public/projects/rahul/projectthree/overview/c.png";
import newlaunchiconprojectthree from "../../../../public/projects/rahul/projectthree/overview/n.png";
import gallery1projectthree from "../../../../public/projects/rahul/projectthree/gallery/1.webp";
import gallery2projectthree from "../../../../public/projects/rahul/projectthree/gallery/2.webp";
import gallery3projectthree from "../../../../public/projects/rahul/projectthree/gallery/3.webp";
import gallery4projectthree from "../../../../public/projects/rahul/projectthree/gallery/4.webp";
import gallery5projectthree from "../../../../public/projects/rahul/projectthree/gallery/5.webp";

// projectfour
import overviewImageprojectfour from "../../../../public/projects/rahul/projectfour/overview/1.webp";
import bannerDesktopImageprojectfour from "../../../../public/projects/rahul/projectfour/banner/1.webp";
import bannerMobileImageprojectfour from "../../../../public/projects/rahul/projectfour/banner/2.webp";
import Locationprojectfour from "../../../../public/projects/rahul/projectfour/location/1.webp";
import Hightlightsprojectfour from "../../../../public/projects/rahul/projectfour/highlights/1.webp";
import floorplan1projectfour from "../../../../public/projects/rahul/projectfour/floorplan/1.webp";
import floorplan2projectfour from "../../../../public/projects/rahul/projectfour/floorplan/2.webp";
import floorplan3projectfour from "../../../../public/projects/rahul/projectfour/floorplan/3.webp";
import floorplan4projectfour from "../../../../public/projects/rahul/projectfour/floorplan/4.webp";
import floorplan5projectfour from "../../../../public/projects/rahul/projectfour/floorplan/5.webp";
import locationiconprojectfour from "../../../../public/projects/rahul/projectfour/overview/l.png";
import caliconprojectfour from "../../../../public/projects/rahul/projectfour/overview/c.png";
import newlaunchiconprojectfour from "../../../../public/projects/rahul/projectfour/overview/n.png";
import gallery1projectfour from "../../../../public/projects/rahul/projectfour/gallery/1.webp";
import gallery2projectfour from "../../../../public/projects/rahul/projectfour/gallery/2.webp";
import gallery3projectfour from "../../../../public/projects/rahul/projectfour/gallery/3.webp";
import gallery4projectfour from "../../../../public/projects/rahul/projectfour/gallery/4.webp";
import gallery5projectfour from "../../../../public/projects/rahul/projectfour/gallery/5.webp";

// projectfive
import overviewImageprojectfive from "../../../../public/projects/rahul/projectfive/overview/1.webp";
import bannerDesktopImageprojectfive from "../../../../public/projects/rahul/projectfive/banner/1.webp";
import bannerMobileImageprojectfive from "../../../../public/projects/rahul/projectfive/banner/2.webp";
import Locationprojectfive from "../../../../public/projects/rahul/projectfive/location/1.webp";
import Hightlightsprojectfive from "../../../../public/projects/rahul/projectfive/highlights/1.webp";
import floorplan1projectfive from "../../../../public/projects/rahul/projectfive/floorplan/1.webp";
import floorplan2projectfive from "../../../../public/projects/rahul/projectfive/floorplan/2.webp";
import floorplan3projectfive from "../../../../public/projects/rahul/projectfive/floorplan/3.webp";
import floorplan4projectfive from "../../../../public/projects/rahul/projectfive/floorplan/4.webp";
import floorplan5projectfive from "../../../../public/projects/rahul/projectfive/floorplan/5.webp";
import locationiconprojectfive from "../../../../public/projects/rahul/projectfive/overview/l.png";
import caliconprojectfive from "../../../../public/projects/rahul/projectfive/overview/c.png";
import newlaunchiconprojectfive from "../../../../public/projects/rahul/projectfive/overview/n.png";
import gallery1projectfive from "../../../../public/projects/rahul/projectfive/gallery/1.webp";
import gallery2projectfive from "../../../../public/projects/rahul/projectfive/gallery/2.webp";
import gallery3projectfive from "../../../../public/projects/rahul/projectfive/gallery/3.webp";
import gallery4projectfive from "../../../../public/projects/rahul/projectfive/gallery/4.webp";
import gallery5projectfive from "../../../../public/projects/rahul/projectfive/gallery/5.webp";

// projectsix
import overviewImageprojectsix from "../../../../public/projects/rahul/projectsix/overview/1.webp";
import bannerDesktopImageprojectsix from "../../../../public/projects/rahul/projectsix/banner/1.webp";
import bannerMobileImageprojectsix from "../../../../public/projects/rahul/projectsix/banner/2.webp";
import Locationprojectsix from "../../../../public/projects/rahul/projectsix/location/1.webp";
import Hightlightsprojectsix from "../../../../public/projects/rahul/projectsix/highlights/1.webp";
import floorplan1projectsix from "../../../../public/projects/rahul/projectsix/floorplan/1.webp";
import floorplan2projectsix from "../../../../public/projects/rahul/projectsix/floorplan/2.webp";
import floorplan3projectsix from "../../../../public/projects/rahul/projectsix/floorplan/3.webp";
import floorplan4projectsix from "../../../../public/projects/rahul/projectsix/floorplan/4.webp";
import floorplan5projectsix from "../../../../public/projects/rahul/projectsix/floorplan/5.webp";
import locationiconprojectsix from "../../../../public/projects/rahul/projectsix/overview/l.png";
import caliconprojectsix from "../../../../public/projects/rahul/projectsix/overview/c.png";
import newlaunchiconprojectsix from "../../../../public/projects/rahul/projectsix/overview/n.png";
import gallery1projectsix from "../../../../public/projects/rahul/projectsix/gallery/1.webp";
import gallery2projectsix from "../../../../public/projects/rahul/projectsix/gallery/2.webp";
import gallery3projectsix from "../../../../public/projects/rahul/projectsix/gallery/3.webp";
import gallery4projectsix from "../../../../public/projects/rahul/projectsix/gallery/4.webp";
import gallery5projectsix from "../../../../public/projects/rahul/projectsix/gallery/5.webp";

// projectseven
import overviewImageprojectseven from "../../../../public/projects/rahul/projectseven/overview/1.webp";
import bannerDesktopImageprojectseven from "../../../../public/projects/rahul/projectseven/banner/1.webp";
import bannerMobileImageprojectseven from "../../../../public/projects/rahul/projectseven/banner/2.webp";
import Locationprojectseven from "../../../../public/projects/rahul/projectseven/location/1.webp";
import Hightlightsprojectseven from "../../../../public/projects/rahul/projectseven/highlights/1.webp";
import floorplan1projectseven from "../../../../public/projects/rahul/projectseven/floorplan/1.webp";
import floorplan2projectseven from "../../../../public/projects/rahul/projectseven/floorplan/2.webp";
import floorplan3projectseven from "../../../../public/projects/rahul/projectseven/floorplan/3.webp";
import floorplan4projectseven from "../../../../public/projects/rahul/projectseven/floorplan/4.webp";
import floorplan5projectseven from "../../../../public/projects/rahul/projectseven/floorplan/5.webp";
import locationiconprojectseven from "../../../../public/projects/rahul/projectseven/overview/l.png";
import caliconprojectseven from "../../../../public/projects/rahul/projectseven/overview/c.png";
import newlaunchiconprojectseven from "../../../../public/projects/rahul/projectseven/overview/n.png";
import gallery1projectseven from "../../../../public/projects/rahul/projectseven/gallery/1.webp";
import gallery2projectseven from "../../../../public/projects/rahul/projectseven/gallery/2.webp";
import gallery3projectseven from "../../../../public/projects/rahul/projectseven/gallery/3.webp";
import gallery4projectseven from "../../../../public/projects/rahul/projectseven/gallery/4.webp";
import gallery5projectseven from "../../../../public/projects/rahul/projectseven/gallery/5.webp";

// projecteight
import overviewImageprojecteight from "../../../../public/projects/rahul/projecteight/overview/1.webp";
import bannerDesktopImageprojecteight from "../../../../public/projects/rahul/projecteight/banner/1.webp";
import bannerMobileImageprojecteight from "../../../../public/projects/rahul/projecteight/banner/2.webp";
import Locationprojecteight from "../../../../public/projects/rahul/projecteight/location/1.webp";
import Hightlightsprojecteight from "../../../../public/projects/rahul/projecteight/highlights/1.webp";
import floorplan1projecteight from "../../../../public/projects/rahul/projecteight/floorplan/1.webp";
import floorplan2projecteight from "../../../../public/projects/rahul/projecteight/floorplan/2.webp";
import floorplan3projecteight from "../../../../public/projects/rahul/projecteight/floorplan/3.webp";
import floorplan4projecteight from "../../../../public/projects/rahul/projecteight/floorplan/4.webp";
import floorplan5projecteight from "../../../../public/projects/rahul/projecteight/floorplan/5.webp";
import locationiconprojecteight from "../../../../public/projects/rahul/projecteight/overview/l.png";
import caliconprojecteight from "../../../../public/projects/rahul/projecteight/overview/c.png";
import newlaunchiconprojecteight from "../../../../public/projects/rahul/projecteight/overview/n.png";
import gallery1projecteight from "../../../../public/projects/rahul/projecteight/gallery/1.webp";
import gallery2projecteight from "../../../../public/projects/rahul/projecteight/gallery/2.webp";
import gallery3projecteight from "../../../../public/projects/rahul/projecteight/gallery/3.webp";
import gallery4projecteight from "../../../../public/projects/rahul/projecteight/gallery/4.webp";
import gallery5projecteight from "../../../../public/projects/rahul/projecteight/gallery/5.webp";

// projectnine
import overviewImageprojectnine from "../../../../public/projects/rahul/projectnine/overview/1.webp";
import bannerDesktopImageprojectnine from "../../../../public/projects/rahul/projectnine/banner/1.webp";
import bannerMobileImageprojectnine from "../../../../public/projects/rahul/projectnine/banner/2.webp";
import Locationprojectnine from "../../../../public/projects/rahul/projectnine/location/1.webp";
import Hightlightsprojectnine from "../../../../public/projects/rahul/projectnine/highlights/1.webp";
import floorplan1projectnine from "../../../../public/projects/rahul/projectnine/floorplan/1.webp";
import floorplan2projectnine from "../../../../public/projects/rahul/projectnine/floorplan/2.webp";
import floorplan3projectnine from "../../../../public/projects/rahul/projectnine/floorplan/3.webp";
import floorplan4projectnine from "../../../../public/projects/rahul/projectnine/floorplan/4.webp";
import floorplan5projectnine from "../../../../public/projects/rahul/projectnine/floorplan/5.webp";
import locationiconprojectnine from "../../../../public/projects/rahul/projectnine/overview/l.png";
import caliconprojectnine from "../../../../public/projects/rahul/projectnine/overview/c.png";
import newlaunchiconprojectnine from "../../../../public/projects/rahul/projectnine/overview/n.png";
import gallery1projectnine from "../../../../public/projects/rahul/projectnine/gallery/1.webp";
import gallery2projectnine from "../../../../public/projects/rahul/projectnine/gallery/2.webp";
import gallery3projectnine from "../../../../public/projects/rahul/projectnine/gallery/3.webp";
import gallery4projectnine from "../../../../public/projects/rahul/projectnine/gallery/4.webp";
import gallery5projectnine from "../../../../public/projects/rahul/projectnine/gallery/5.webp";

// projectten
import overviewImageprojectten from "../../../../public/projects/rahul/projectten/overview/1.webp";
import bannerDesktopImageprojectten from "../../../../public/projects/rahul/projectten/banner/1.webp";
import bannerMobileImageprojectten from "../../../../public/projects/rahul/projectten/banner/2.webp";
import Locationprojectten from "../../../../public/projects/rahul/projectten/location/1.webp";
import Hightlightsprojectten from "../../../../public/projects/rahul/projectten/highlights/1.webp";
import floorplan1projectten from "../../../../public/projects/rahul/projectten/floorplan/1.webp";
import floorplan2projectten from "../../../../public/projects/rahul/projectten/floorplan/2.webp";
import floorplan3projectten from "../../../../public/projects/rahul/projectten/floorplan/3.webp";
import floorplan4projectten from "../../../../public/projects/rahul/projectten/floorplan/4.webp";
import floorplan5projectten from "../../../../public/projects/rahul/projectten/floorplan/5.webp";
import locationiconprojectten from "../../../../public/projects/rahul/projectten/overview/l.png";
import caliconprojectten from "../../../../public/projects/rahul/projectten/overview/c.png";
import newlaunchiconprojectten from "../../../../public/projects/rahul/projectten/overview/n.png";
import gallery1projectten from "../../../../public/projects/rahul/projectten/gallery/1.webp";
import gallery2projectten from "../../../../public/projects/rahul/projectten/gallery/2.webp";
import gallery3projectten from "../../../../public/projects/rahul/projectten/gallery/3.webp";
import gallery4projectten from "../../../../public/projects/rahul/projectten/gallery/4.webp";
import gallery5projectten from "../../../../public/projects/rahul/projectten/gallery/5.webp";



export const developerrahul = {
  properties: [
    {
      name: "Rahul Aston",
      image: bannerMobileImageaston,
      price: "On Request",
      state: "Pune",
      developer: "rahul",
      location: "Hinjewadi, Pune",
      projectlocation: "Pune",
      bed: "2,3 BHK Apartments",
      size: "779-978 sq.ft.",
      url: `/rahul-aston`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Rahul Aston",
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};
export const Headers = {
  logo: s,
  data: {
    experience: "2006",
  },
  about: `rahul, a 100% FDI funded real-estate developer, backed by rahul Holdings Pte. Ltd., Singapore, the real estate investing division of the AT Holdings group of companies. AT Capital, headquartered in Singapore, was established with the aim of capitalizing on global opportunities within both established and emerging sectors.`,
};


export const projectsrahul = {

  aston: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageaston,
      bannerMobileImage: bannerMobileImageaston,
      textOverlay: "",
      data: {
        title: "Rahul Aston",
        subtitle: " Hinjewadi Pune",
        starting_price: "On Request ",
        payment_plan: "CLP",
        rerano: "--",
        status: "Under Construction"
      }
    },

    overview: {
      heading: "Rahul Aston",
      description: [
        "In Hinjewadi Pune, Rahul Aston is redefined modern city life with its thoughtful housing and world -class functions. Located in the center of Hinjewadi - the city's Rich It and Business Hub - Rahul Aston offers an ideal mix of comfort, connection and convenience for professionals and families.",
        "These premium apartments in Hinjwadi Pune are designed to meet your lifestyle needs, ensuring huge interiors, natural light and smart layouts. Whether you are the first homebuir or looking for upgrading, Rahul Eston provides the right housing solutions with the configurations limit including 2 BHK apartments in Pune Hinjwadi.",
        "Rahul Eston not only stands out for his location, but also for a wide range of lifestyle features such as a clubhouse, gym, landscape space, children's sports area and more. The proximity to top IT parks, schools, hospitals and entertainment areas makes it an excellent choice for those who want convenience without compromising on the quality.",
        "For those searching for apartments in Hinjewadi Pune that provide a good balance between luxury and strength, Rahul Eston is an opportunity not to remember. The project promises to experience a vibrant society with a safe, quiet environment for your family.",
        "If you are in the market for 2 BHK apartments in Pune Hinjewadi, Rahul Eston is qualified to top the list. With its Premium Prasad, excellent connection and price-k-wealth awards, it is ready to become one of the most desirable addresses in the project sector."
      ],
      keywordLinks: {
        "": "",
      },
      image: overviewImageaston,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconaston,
          title: "₹ On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconaston,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconaston,
          title: "Under Construction ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK  ",
          area: "  779 - 799 sq.ft.",
          price: "₹ On Request",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK ",
          area: " 946 - 978 sq.ft.   ",
          price: "₹ On Request",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "2 BHK  ",
        area: "  779 - 799 sq.ft.",
        price: "₹ On Request",
        image: floorplan1aston,
      },
      {
        type: "3 BHK ",
        area: " 946 - 978 sq.ft.   ",
        price: "₹ On Request",
        image: floorplan2aston,
      }
    ],

    highlights: {
      images: Hightlightsaston,
      tagline: "Highlights",
      features: [
        "Prime Location in Hinjewadi IT Hub ",
        "Premium Lifestyle Amenities Included ",
        "Excellent Connectivity to Mumbai Highway ",
        "Thoughtfully Designed Green Spaces ",
        "Smart Home Features for Urban Living ",
      ],
    },

    location: {
      image: Locationaston,
      data: [
        {
          airport: {
            distance_time: "22.2 Km",
            name: "Pune International Airport"
          },
          school: {
            distance_time: "3.6 Km",
            name: "Blue Ridge Public School"
          },
          railwayormetro: {
            distance_time: "9.3 Km",
            name: "TCS metro station "
          },
          hospital: {
            distance_time: "2.3 Km",
            name: "Sanjeevani Multispeciality Hospital"
          },
          mall: {
            distance_time: "1 Km",
            name: "Xion Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1aston },
        { image: gallery2aston },
        { image: gallery3aston },
        { image: gallery4aston },
        { image: gallery5aston },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in  Rahul Aston, kindly share more details.",
    },

    faq: [
      {
        question: "What types of apartments are available at Rahul Aston?",
        answer: "Rahul Aston offers spacious 2 BHK and 3 BHK apartments.",
      },
      {
        question: "What is the size range of the apartments?",
        answer: "The apartments range in size from approximately 779 sq.ft. to 978 sq.ft.",
      },
      {
        question: "Where is Rahul Aston located?",
        answer: "The project is strategically situated in Hinjewadi Phase 1, near D-Mart and Sujata Mastani.",
      },
      {
        question: "What amenities does Rahul Aston offer?",
        answer: "Rahul Aston boasts over 30 world-class amenities, including a sky lounge and a stargazing arena.",
      },
      {
        question: "How many towers and floors are there in the project?",
        answer: "The project comprises 5 towers, each with 2 basements + ground + 22 floors, offering a total of 192 units.",
      },
      {
        question: "What is the total area of the project?",
        answer: "Rahul Aston is spread across 6 acres.",
      },
      {
        question: "When is the possession date for Rahul Aston?",
        answer: "The expected possession date for Rahul Aston is April 2026.",
      },
      {
        question: "Is the project RERA registered?",
        answer: "Yes, Rahul Aston is RERA registered with the following registration numbers: P52100026878 and P52100076854.",
      },
      {
        question: "What types of apartments are available at Rahul Aston?",
        answer: "Rahul Aston offers spacious 2 BHK and 3 BHK apartments",
      },
      {
        question: "What is the size range of the apartments?",
        answer: "The apartments range in size from approximately 779 sq.ft. to 978 sq.ft.",
      },
     
    ],
    
    


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projecttwo: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojecttwo,
      bannerMobileImage: bannerMobileImageprojecttwo,
      textOverlay: "",
      data: {
        title: "rahul The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "rahul The Trillion",
      description: [
        "rahul The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by rahul Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at rahul Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at rahul Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of rahul The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "rahul": "/developers/rahul",
      },
      image: overviewImageprojecttwo,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojecttwo,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojecttwo,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojecttwo,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projecttwo,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projecttwo,
      }
    ],

    highlights: {
      images: Hightlightsprojecttwo,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojecttwo,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projecttwo },
        { image: gallery2projecttwo },
        { image: gallery3projecttwo },
        { image: gallery4projecttwo },
        { image: gallery5projecttwo },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in rahul The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is rahul The Trillion located?",
        answer: `rahul The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at rahul The Trillion?",
        answer: `rahul The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in rahul The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at rahul The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, rahul The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of rahul The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at rahul The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of rahul The Trillion?",
        answer: `rahul The Trillion is developed by rahul Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is rahul The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, rahul The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from rahul The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectthree: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectthree,
      bannerMobileImage: bannerMobileImageprojectthree,
      textOverlay: "",
      data: {
        title: "rahul The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "rahul The Trillion",
      description: [
        "rahul The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by rahul Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at rahul Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at rahul Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of rahul The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "rahul": "/developers/rahul",
      },
      image: overviewImageprojectthree,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectthree,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectthree,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectthree,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectthree,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectthree,
      }
    ],

    highlights: {
      images: Hightlightsprojectthree,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectthree,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectthree },
        { image: gallery2projectthree },
        { image: gallery3projectthree },
        { image: gallery4projectthree },
        { image: gallery5projectthree },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in rahul The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is rahul The Trillion located?",
        answer: `rahul The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at rahul The Trillion?",
        answer: `rahul The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in rahul The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at rahul The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, rahul The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of rahul The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at rahul The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of rahul The Trillion?",
        answer: `rahul The Trillion is developed by rahul Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is rahul The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, rahul The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from rahul The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfour: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfour,
      bannerMobileImage: bannerMobileImageprojectfour,
      textOverlay: "",
      data: {
        title: "rahul The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "rahul The Trillion",
      description: [
        "rahul The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by rahul Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at rahul Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at rahul Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of rahul The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "rahul": "/developers/rahul",
      },
      image: overviewImageprojectfour,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfour,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfour,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectfour,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfour,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfour,
      }
    ],

    highlights: {
      images: Hightlightsprojectfour,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfour,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfour },
        { image: gallery2projectfour },
        { image: gallery3projectfour },
        { image: gallery4projectfour },
        { image: gallery5projectfour },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in rahul The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is rahul The Trillion located?",
        answer: `rahul The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at rahul The Trillion?",
        answer: `rahul The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in rahul The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at rahul The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, rahul The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of rahul The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at rahul The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of rahul The Trillion?",
        answer: `rahul The Trillion is developed by rahul Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is rahul The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, rahul The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from rahul The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfive: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfive,
      bannerMobileImage: bannerMobileImageprojectfive,
      textOverlay: "",
      data: {
        title: "rahul The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "rahul The Trillion",
      description: [
        "rahul The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by rahul Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at rahul Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at rahul Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of rahul The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "rahul": "/developers/rahul",
      },
      image: overviewImageprojectfive,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfive,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfive,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectfive,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfive,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfive,
      }
    ],

    highlights: {
      images: Hightlightsprojectfive,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfive,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfive },
        { image: gallery2projectfive },
        { image: gallery3projectfive },
        { image: gallery4projectfive },
        { image: gallery5projectfive },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in rahul The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is rahul The Trillion located?",
        answer: `rahul The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at rahul The Trillion?",
        answer: `rahul The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in rahul The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at rahul The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, rahul The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of rahul The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at rahul The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of rahul The Trillion?",
        answer: `rahul The Trillion is developed by rahul Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is rahul The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, rahul The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from rahul The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectsix: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectsix,
      bannerMobileImage: bannerMobileImageprojectsix,
      textOverlay: "",
      data: {
        title: "rahul The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "rahul The Trillion",
      description: [
        "rahul The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by rahul Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at rahul Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at rahul Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of rahul The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "rahul": "/developers/rahul",
      },
      image: overviewImageprojectsix,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectsix,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectsix,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectsix,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectsix,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectsix,
      }
    ],

    highlights: {
      images: Hightlightsprojectsix,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectsix,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectsix },
        { image: gallery2projectsix },
        { image: gallery3projectsix },
        { image: gallery4projectsix },
        { image: gallery5projectsix },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in rahul The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is rahul The Trillion located?",
        answer: `rahul The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at rahul The Trillion?",
        answer: `rahul The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in rahul The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at rahul The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, rahul The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of rahul The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at rahul The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of rahul The Trillion?",
        answer: `rahul The Trillion is developed by rahul Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is rahul The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, rahul The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from rahul The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectseven: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectseven,
      bannerMobileImage: bannerMobileImageprojectseven,
      textOverlay: "",
      data: {
        title: "rahul The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "rahul The Trillion",
      description: [
        "rahul The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by rahul Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at rahul Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at rahul Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of rahul The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "rahul": "/developers/rahul",
      },
      image: overviewImageprojectseven,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectseven,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectseven,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectseven,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectseven,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectseven,
      }
    ],

    highlights: {
      images: Hightlightsprojectseven,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectseven,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectseven },
        { image: gallery2projectseven },
        { image: gallery3projectseven },
        { image: gallery4projectseven },
        { image: gallery5projectseven },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in rahul The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is rahul The Trillion located?",
        answer: `rahul The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at rahul The Trillion?",
        answer: `rahul The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in rahul The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at rahul The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, rahul The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of rahul The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at rahul The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of rahul The Trillion?",
        answer: `rahul The Trillion is developed by rahul Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is rahul The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, rahul The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from rahul The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projecteight: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojecteight,
      bannerMobileImage: bannerMobileImageprojecteight,
      textOverlay: "",
      data: {
        title: "rahul The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "rahul The Trillion",
      description: [
        "rahul The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by rahul Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at rahul Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at rahul Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of rahul The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "rahul": "/developers/rahul",
      },
      image: overviewImageprojecteight,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojecteight,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojecteight,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojecteight,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projecteight,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projecteight,
      }
    ],

    highlights: {
      images: Hightlightsprojecteight,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojecteight,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projecteight },
        { image: gallery2projecteight },
        { image: gallery3projecteight },
        { image: gallery4projecteight },
        { image: gallery5projecteight },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in rahul The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is rahul The Trillion located?",
        answer: `rahul The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at rahul The Trillion?",
        answer: `rahul The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in rahul The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at rahul The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, rahul The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of rahul The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at rahul The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of rahul The Trillion?",
        answer: `rahul The Trillion is developed by rahul Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is rahul The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, rahul The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from rahul The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectnine: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectnine,
      bannerMobileImage: bannerMobileImageprojectnine,
      textOverlay: "",
      data: {
        title: "rahul The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "rahul The Trillion",
      description: [
        "rahul The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by rahul Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at rahul Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at rahul Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of rahul The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "rahul": "/developers/rahul",
      },
      image: overviewImageprojectnine,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectnine,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectnine,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectnine,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectnine,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectnine,
      }
    ],

    highlights: {
      images: Hightlightsprojectnine,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectnine,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectnine },
        { image: gallery2projectnine },
        { image: gallery3projectnine },
        { image: gallery4projectnine },
        { image: gallery5projectnine },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in rahul The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is rahul The Trillion located?",
        answer: `rahul The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at rahul The Trillion?",
        answer: `rahul The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in rahul The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at rahul The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, rahul The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of rahul The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at rahul The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of rahul The Trillion?",
        answer: `rahul The Trillion is developed by rahul Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is rahul The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, rahul The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from rahul The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectten: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectten,
      bannerMobileImage: bannerMobileImageprojectten,
      textOverlay: "",
      data: {
        title: "rahul The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "rahul The Trillion",
      description: [
        "rahul The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by rahul Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at rahul Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at rahul Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of rahul The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "rahul": "/developers/rahul",
      },
      image: overviewImageprojectten,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectten,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectten,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectten,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectten,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectten,
      }
    ],

    highlights: {
      images: Hightlightsprojectten,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectten,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectten },
        { image: gallery2projectten },
        { image: gallery3projectten },
        { image: gallery4projectten },
        { image: gallery5projectten },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in rahul The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is rahul The Trillion located?",
        answer: `rahul The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at rahul The Trillion?",
        answer: `rahul The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in rahul The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at rahul The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, rahul The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of rahul The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at rahul The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of rahul The Trillion?",
        answer: `rahul The Trillion is developed by rahul Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is rahul The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, rahul The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from rahul The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
};
